import { createFileRoute } from "@tanstack/react-router";
import { Home } from "@/components/screens/home";

export const Route = createFileRoute("/{-$locale}/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Home />;
}
